<template>
<v-container>
  <GroupEditor ref="GroupEditor"
    :course-id="this.selectedCourse">
  </GroupEditor>

	<ApprovalForm ref="ApprovalForm" 
		@registration-approved="refresh"
		@registration-rejected="refresh"
		@registration-restored="refresh"
		@registration-cancelled="refresh"
    @update-registration="updateRegistration">
	</ApprovalForm>

	<EnrollForm ref="EnrollForm" 
		@registration-enrolled="refresh"
		@registration-rejected="refresh">
	</EnrollForm>

  <TransferForm ref="TransferForm" 
		@registration-transferred="refresh">
	</TransferForm>

  <v-dialog v-model="registrationUpdateDialog" max-width="800px" eager>
    <RegisterForm ref="RegisterForm"
      @registration-updated="refresh(); registrationUpdateDialog = false;"
      @dialog-closed="registrationUpdateDialog = false">
    </RegisterForm>
  </v-dialog>

  <v-data-table class="d-print-only" ref="PrintArea"
    v-model="selectedRegistrations"
    :headers="headers"
    :items="registrations"
    :loading="loading"
    :search="searchTerm"
    :custom-filter="filters.registrationFilter"
    :footer-props="footerProps"
    :items-per-page="itemsPerPage">
    <template v-slot:top>
      <v-container class="d-print-none">
        <div class="d-flex justify-space-around" >
          <h2>Registrations</h2>
          <v-spacer></v-spacer>

          <v-btn class="mr-2" color="primary" small dark
            @click="refresh()">
            <v-icon left small>mdi-refresh</v-icon>
            Refresh
          </v-btn>

          <v-btn class="mr-2" color="primary" small dark
            @click="downloadCredentialsCsv()"
            v-if="!reportMode">
            <v-icon left small>mdi-download</v-icon>
            LMS
          </v-btn>

          <v-btn color="primary" small dark
            @click="print()"
            v-if="reportMode">
            <v-icon left small>mdi-printer</v-icon>
            Print
          </v-btn>
        </div>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              label="Search"
              prepend-icon="mdi-magnify"
              v-model="searchTerm"
              autocomplete="off"/>
          </v-col>
          
          <v-col cols="12" md="3">
            <v-menu
              ref="DateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :disabled="(status == REGISTRATION_STATUS.ENROLLED && selectedCourseGroup > 0)"
                  v-model="date"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hint="Select 2 dates">
                </v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                scrollable
                range
                @change="refresh()">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.DateMenu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="selectedCourseType"
              @change="getCourses"
              :items="courseTypes"
              item-text="title"
              item-value="id"
              label="Type">
            </v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="selectedCourse"
              @change="refresh"
              :items="courses"
              item-text="title"
              item-value="id"
              label="Course">
            </v-select>
          </v-col>

        </v-row>
        <v-row v-if="selectedCourse && status == REGISTRATION_STATUS.ENROLLED">
          <v-col cols="12" md="4" offset-md="4">
            <v-select
              v-model="selectedCourseGroup"
              @change="getRegistrations"
              :items="courseGroups"
              item-text="title"
              item-value="id"
              label="Group">
              <template v-slot:append v-if="!reportMode">
                <v-btn
                  text
                  class="ma-0"
                  @click="editGroups">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-select>
          </v-col>

        </v-row>
      </v-container>        
        <!-- <v-divider
        class="mx-4"
        inset
        vertical
        ></v-divider> -->
    </template>

    <template v-slot:item._index="{ item }" >
      {{ registrations.indexOf(item) + 1 }}
    </template>

    <template v-slot:item.firstname="{ item }">
      {{ item.firstname }} {{ item.extname }}
    </template>

    <template v-slot:item._address="{ item }">
      {{ item.city }}, {{ item.barangay }}
    </template>

    <template v-slot:item._course="{ item }">
      {{ item['course.shortTitle'] || item['course.title'] }}
    </template>

    <template v-slot:item._approver="{ item }">
      {{ getUserName(item.approverId) }}
    </template>

    <template v-slot:item._rejecter="{ item }">
      {{ getUserName(item.rejecterId) }}
    </template>

    <template v-slot:item._enroller="{ item }">
      {{ getUserName(item.approverId) }}
    </template>

    <template v-slot:item._actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="transferRegistration(item)">
        mdi-swap-horizontal-bold
      </v-icon>
      <v-icon
        small
        class="mr-2"
        @click="updateRegistration(item)">
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteRegistration(item)">
        mdi-delete
      </v-icon>
    </template>

    <template v-slot:item._approveAction="{ item }">
      <v-btn small color="blue" dark
        @click="$refs.ApprovalForm.init(item)">
        <v-icon left small>mdi-magnify</v-icon>
        Review
      </v-btn>
    </template>

    <template v-slot:item._enrollAction="{ item }">
      <v-btn small color="blue" dark
        @click="$refs.EnrollForm.init(item)">
        <v-icon left small>mdi-check</v-icon>
        Enroll
      </v-btn>
    </template>
			<!-- 
				<template v-slot:no-data>
					No Data Found
				</template> 
			-->
  </v-data-table>
</v-container>
</template>

<script>
import Moment from 'moment'
import Api from '../../services/api'
import Notify from '../../services/notify'
import Report from '../../services/report'
import Auth from '../../services/auth'

import DataTableMixin from '../../mixins/data-table.mixin'
import CourseMixin from '../../mixins/course.mixin'

import GroupEditor from '../course/group/GroupEditor'
import ApprovalForm from './ApprovalForm'
import EnrollForm from '../enroll/EnrollForm'
import RegisterForm from '../register/RegisterForm'
import TransferForm from '../register/TransferForm'
import RegistrationService from './services/registration.service';

import { REGISTRATION_STATUS, PERSONNEL } from '../../services/constants'

export default {
  name: 'RegistrationList',
  components: { GroupEditor, ApprovalForm, EnrollForm, RegisterForm, TransferForm, },
  props: [ 'status', 'reportMode', 'enrollMode' ],
  mixins: [ CourseMixin, DataTableMixin ],
  data() {
    return {
      REGISTRATION_STATUS,
      registrations: [],
      loading: false,
      searchTerm: '',
      headers: [],
      users: [],
      dateMenu: false,
      date: [],
      registrationUpdateDialog: false,
    }
  },
  mounted() {
    this.setHeaders();

    this.getCourseTypes();
    this.getCourses();

    Api.user.getAllNames()
      .then((response) => {
        this.users = response.data;
      });

    this.date = [
      Moment().subtract(1, 'year').format('YYYY-MM-DD'),
			// Moment().startOf('year').format('YYYY-MM-DD'),
			Moment().startOf('endOf').format('YYYY-MM-DD'),
		];
    this.refresh();
  },
  methods: {
    setHeaders() {
      this.headers = [];
      switch(this.status) {
        case REGISTRATION_STATUS.UNPROCESSED:
          this.headers = [
            { text: 'Lastname', value: 'lastname', align: 'start' },
            { text: 'Firstname', value: 'firstname' },
            { text: 'Middlename', value: 'middlename' },
            { text: 'Address', value: '_address' },
            { text: 'Mobile', value: 'mobile' },
            { text: 'Course', value: '_course'},
            { text: 'Registration', value: 'registerDateTime' },
            { text: 'Actions', value: '_actions', sortable: false },
            { text: 'Review', value: '_approveAction', sortable: false  },
          ];
        break;

        case REGISTRATION_STATUS.APPROVED:
          this.headers = [ 
            { text: 'Lastname', value: 'lastname', align: 'start' },
            { text: 'Firstname', value: 'firstname' },
            { text: 'Middlename', value: 'middlename' },
            { text: 'Address', value: '_address' },
            { text: 'Mobile', value: 'mobile' },
            { text: 'Course', value: '_course' },
            { text: 'Approved By', value: '_approver' },
            { text: 'Approved On', value: 'approveDateTime' },
            { text: 'Actions', value: '_actions', sortable: false },
            { text: 'Review', value: '_approveAction', sortable: false },
          ];
        break;

        case REGISTRATION_STATUS.REJECTED:
          this.headers = [ 
            { text: 'Lastname', value: 'lastname', align: 'start' },
            { text: 'Firstname', value: 'firstname' },
            { text: 'Middlename', value: 'middlename' },
            { text: 'Address', value: '_address' },
            { text: 'Mobile', value: 'mobile' },
            { text: 'Course', value: '_course' },
            { text: 'Rejected By', value: '_rejecter' },
            { text: 'Rejected On', value: 'rejectDateTime' },
            { text: 'Actions', value: '_actions', sortable: false },
            { text: 'Review', value: '_approveAction', sortable: false },
          ];
        break;

        case REGISTRATION_STATUS.ENROLLED:
          this.headers = [ 
            { text: 'Lastname', value: 'lastname', align: 'start' },
            { text: 'Firstname', value: 'firstname' },
            { text: 'Middlename', value: 'middlename' },
            { text: 'Address', value: '_address' },
            { text: 'Mobile', value: 'mobile' },
            { text: 'Course', value: '_course' },
            { text: 'Enrolled By', value: '_enroller' },
            { text: 'Enrolled On', value: 'enrollDateTime' },
            { text: 'Actions', value: '_actions', sortable: false  },
            { text: 'Review', value: '_approveAction', sortable: false },
          ];
        break;
      }

      if(this.enrollMode) {
        this.headers = this.addHeader(this.headers, 'Enroll', '_enrollAction');
        this.headers = this.removeHeader(this.headers, '_approveAction');
      }

      // added index in all
      this.headers.splice(0, 0, { text: 'Reg.ID', value: 'id' } );

      // remove Actions and Review header
      if(this.reportMode) {
        this.headers = this.removeHeader(this.headers, '_actions');
        this.headers = this.removeHeader(this.headers, '_approveAction');
        this.headers = this.removeHeader(this.headers, '_enrollAction');

        this.headers = this.removeHeader(this.headers, '_approver');
        this.headers = this.removeHeader(this.headers, '_enroller');
        this.headers = this.removeHeader(this.headers, '_rejecter');

        this.headers.splice(this.headers.length - 2, 0, { text: 'Education', value: 'education' } );
        this.headers.splice(this.headers.length - 2, 0, { text: 'Email', value: 'email' } );
        this.headers.splice(this.headers.length - 2, 0, { text: 'Mobile', value: 'mobile' } );
      }
    },

    downloadCredentialsCsv() {
      let csvData = RegistrationService.generateCredentials(this.registrations);
      Report.toCSV(csvData, 'registrations.csv');
    },

    print() {
      let reportTitle = 'Registrations';
      switch(this.status) {
        case REGISTRATION_STATUS.UNPROCESSED: reportTitle='Unprocessed Registrations'; break;
        case REGISTRATION_STATUS.APPROVED: reportTitle='Approved Registrations'; break;
        case REGISTRATION_STATUS.ENROLLED: reportTitle='Officially Enrolled'; break;
        case REGISTRATION_STATUS.REJECTED: reportTitle='Rejected Registrations'; break;
      }

      let signatories = [
        {
          action: 'Prepared By:',
          name: Auth.getLoggedUser().firstname.toUpperCase() + ' '
            + ((Auth.getLoggedUser().middlename)? Auth.getLoggedUser().middlename.charAt(0).toUpperCase() : '')
            + Auth.getLoggedUser().lastname.toUpperCase(),
          title: Auth.getLoggedUser().title || 'N/A',
        },
        {
          action: 'Noted By:',
          name: PERSONNEL.CENTER_REGISTRAR.NAME,
          title: PERSONNEL.CENTER_REGISTRAR.TITLE,
        },
        {
          action: 'Approved By:',
          name: PERSONNEL.TRAINING_HEAD.NAME,
          title: PERSONNEL.TRAINING_HEAD.TITLE,
        },
        {
          action: 'Approved By:',
          name: PERSONNEL.CENTER_ADMINISTRATOR.NAME,
          title: PERSONNEL.CENTER_ADMINISTRATOR.TITLE,
        },
      ];

      let html = this.$refs.PrintArea.$el.outerHTML;
      let selectedCourse = this.courses.find(course => {
        return course.id == this.selectedCourse;
      });
      Report.print(reportTitle, selectedCourse.title, html, signatories, 'registration.css');
    },

    refresh() {
      this.setHeaders();
      if(this.selectedCourse) {
        this.headers = this.removeHeader(this.headers, '_course');
        this.getCourseGroups(this.selectedCourse)
          .then(() => {
            this.getRegistrations();
          })
          .finally(() => {                          
            if(this.courseGroups.length > 0) {
              this.selectedCourseGroup = this.courseGroups[0].id;
            } else {
              this.selectedCourseGroup = 0;
            }
          });
      } else {
        this.getRegistrations();
        this.selectedCourseGroup = 0;
      }

    },

    getRegistrations() {
      if(this.date.length < 2) {
        return;
      }

     
      // ONLY visible on Enrolled
      if(this.status == REGISTRATION_STATUS.ENROLLED && this.selectedCourseGroup) {
        this.date[0] = Moment('2020-01-01').format('YYYY-MM-DD');
        this.date[1] = Moment().startOf('endOf').format('YYYY-MM-DD');
      } else {
        this.selectedCourseGroup = 0;
      }

      // check if ALL is selected
      if(!this.selectedCourse) {
        this.selectedCourseGroup = null;
      }

      this.loading = true;
      Api.registration.getAll(
        this.date[0],
        this.date[1],
        this.selectedCourseType,
        this.selectedCourseGroup,
        this.selectedCourse,
        this.status,
      )
        .then((response) => {
          this.registrations = response.data;
        })
        .catch(() => {
          this.registrations = [];
        })
        .finally(() => {
          this.loading = false;
          this.itemsPerPage = (this.selectedCourse)? -1 : 15;
        });
    },

    updateRegistration(item) {
      this.registrationUpdateDialog = true;
      this.$refs.RegisterForm.updateRegistration(item.id);
    },

    deleteRegistration(item) {
      Notify.confirm('Delete Registration?', 'This will delete the registration without providing any feedback to the applicant.')
        .then(() => {
          Api.registration.delete(item.id)
            .then(() => {
              Notify.success.itemDeleted();
              this.refresh();
            });
        }).catch(() => {});
    },

    transferRegistration(item) {
      this.$refs.TransferForm.init(item.id);
    },

    editGroups() {
      this.$refs.GroupEditor.init();
    },

    getUserName(userId) {
      for(let i=0; i<this.users.length; i++) {
        if(this.users[i].id == userId) {
          let user = this.users[i];
          return user.firstname[0] + '. ' + user.lastname;
        }
      }

      return 'N/A';
    },
  }
}
</script>